export function formatEuroCurrency(value, locale = "fr",decimal=3,alt="",val="") {
  const locales = { en: "en-US", fr: "fr-FR", de: "de-DE" };
if(isNaN(value) || value==0){
  return alt
}
   const formatted =  new Intl.NumberFormat(locales[locale] || locales.fr, {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: decimal
  }).format(Math.floor(value * 1000) / 1000) ;  // Truncate to 3 decimals

  // 🔥 Remove non-breaking spaces before €, then trim
 return formatted // Truncate to 3 decimals
}
 

export const formatWithSpace = (num, language = "fr") =>
    new Intl.NumberFormat(
        language === "fr" ? "fr-FR" : "en-US",
        {
            useGrouping: true,
            minimumFractionDigits: 0,
            maximumFractionDigits: 3
        }
    ).format(num);